import {configureStore} from '@reduxjs/toolkit';
import settingsReducer from '../slices/settingsSlice';
import counterReducer from '../slices/counterSlice';
import productsReducer from '../slices/productSlice';
import brandReducer from '../slices/brandSlice';
import categoryReducer from '../slices/categorySlice';
import cartReducer from '../slices/cartSlice';
import filterReducer from '../slices/filterSlice';
import profileReducer from '../slices/profileSlice';
import billingReducer from '../slices/billingSlice';
import orderReducer from '../slices/orderSlice';


export default configureStore({
    reducer:{
        settings: settingsReducer,
        counter: counterReducer,
        products: productsReducer,
        brand: brandReducer,
        category: categoryReducer,
        cart: cartReducer,
        filter: filterReducer,
        profile:profileReducer,
        billing:billingReducer,
        order:orderReducer
    }
})